// Validates and transforms given input and Joi validator for form

/**
 * Validates and transforms given input and Joi validator for form
 * @param {any} validator
 * @param {string} input
 * @return {string} returns value and errors or just value if no errors
 */
function validate (validator: any, input: string) {
  const { value, error } = validator.validate(input, { abortEarly: false, errors: { label: false } })

  if (error) {
    const errors = {}

    for (const detail of error.details) {
      errors[detail.path.join('.')] = detail.message
    }

    return { value, error, errors }
  }

  return { value }
}

export { validate }
